<template>
    <ProjectDescriptionText :jsonData="performancesData" :basePath="'/performances'" />
</template>

<script>  
    import ProjectDescriptionText from "../components/ProjectDescriptionText.vue"
    import performancesData from '@/assets/data/performances.json';

    export default {
        name: 'Performances',
        components: {
            ProjectDescriptionText
        },
        data() {
            return {
                performancesData
            }
        }
    }
</script>